<template>
  <el-container class="home-wrap home_wrap_buy">
    <el-main class="buy-table">
      <div class="flex-row-center buy-header buy_header_none">
        {{$t('Store')}}
      </div>
      <div class="flex-col-center buy-main buy_main_col">
         <div class="buy-main-choose">
           {{$t('Choose your subscription plan and get started')}}
         </div>
         <div class="buy-main-bound">
           <div class="buy-main-row flex-row-center buy_main_low">
            <div class="buy_margin_sub">
              <div class="grid-content flex-col-start">
                <p class="grid-content-p">{{$t('MONTHLY')}}</p>
                <p class="grid-content-month-p">{{$t('$ {Month} / Month', { Month: this.oneMonth })}}</p>
                <p class="grid-content-devices-p"> {{$t('Can be bound to')}} <span style="color:#2bcf88">2</span> {{$t('devices')}} </p>
                <el-button class="normalBtn buy-main-btn" @click="onBuyNow(monthOne)">{{$t('Subscribe')}}</el-button>
              </div>
            </div>
            <div class="buy_margin_sub">
              <div class="grid-content flex-col-start">
                <p class="grid-content-p">{{$t('QUARTERLY')}}</p>
                <p class="grid-content-month-p">{{$t('$ {Month} / Month', { Month: this.oneMonthRight })}}</p>
                <p class="grid-content-devices-p">{{$t('Can be bound to')}} <span style="color:#2bcf88">10</span> {{$t('devices')}}</p>
                <el-button class="normalBtn buy-main-btn" @click="onBuyNow(quarterly)">{{$t('Subscribe')}}</el-button>
              </div>
            </div>
            <div class="buy_margin_sub">
              <div class="grid-content flex-col-start">
                <p class="grid-content-p">{{$t('ANNUAL')}}</p>
                <p class="grid-content-month-p">{{$t('$ {Month} / Month', { Month: this.oneMonthLeft })}}</p>
                <p class="grid-content-devices-p">{{$t('Can be bound to')}} <span style="color:#2bcf88">20</span> {{$t('devices')}}</p>
                <el-button class="normalBtn buy-main-btn" @click="onBuyNow(annual)">{{$t('Subscribe')}}</el-button>
              </div>
            </div>
          </div>
         </div>
         <div class="buy-main-note buy_main_note_none">
           {{$t("Note: the number of devices refers to the number of children's devices that can be bound. Binding is to access your child's device and install it from Google play.")}}
         </div>
      </div>
      <div class="flex-row-center buy-footer buy_footer_none">
        <el-button @click="Return" class="normalBtn buy-footer-btn">{{$t('Return')}}
        </el-button>
      </div>
    </el-main>
  </el-container>
</template>

<script>
const ultimateCode = {
  twelve: 620161,
  three: 620160,
  one: 620159
}
export default {
  name: 'buy',
  props: ['userid', 'device'],
  data () {
    return {
      buyInfo: [],
      annual: 12,
      oneMonthLeft: '',
      oneMonthRight: '',
      oneMonth: '',
      monthOne: 1,
      quarterly: 3
    }
  },
  methods: {
    Return () {
      this.$router.go(-1)
    },
    // 订阅
    async onBuyNow (Month) {
      if (this.$Demo) {
        const result = await this.$http.get('/MDM/Add')
        console.log(result)
      } else {
        let code = Month === 12 ? ultimateCode.twelve : (Month === 3 ? ultimateCode.three : ultimateCode.one)
        window.Paddle.Checkout.open({ product: code })
      }
    },
    // 月价格
    getOneMonthPrice () {
      let currentItem = this.buyInfo.filter(c => c.Month === this.monthOne)[0]
      this.oneMonth = (currentItem.Price / this.monthOne).toFixed(2)
      // console.log(this.oneMonth)
    },
    // 季度单月价格
    getQuarterlyOneMonthPrice () {
      let currentItem = this.buyInfo.filter(c => c.Month === this.quarterly)[0]
      let reg = /([0-9]+\.[0-9]{2})[0-9]*/
      let numReg = (currentItem.Price / this.quarterly).toFixed(5)
      this.oneMonthRight = numReg.replace(reg, '$1')
      console.log(this.oneMonthRight)
    },
    // 年度单月价格
    getAnnualOneMonthPrice () {
      let currentItem = this.buyInfo.filter(c => c.Month === this.annual)[0]
      this.oneMonthLeft = (currentItem.Price / this.annual).toFixed(2)
      // console.log(this.oneMonthLeft)
    },
    // 获取价格
    async getbuyInfo () {
      try {
        const result = await this.$http.get('/MDM/GetProductInfo', null)
        console.log(result)
        this.buyInfo = result.data ? result.data.reverse().filter(c => c.Rank !== 1) : []
        // console.log(this.buyInfo)
        this.getAnnualOneMonthPrice()
        this.getQuarterlyOneMonthPrice()
        this.getOneMonthPrice()
      } catch (error) {
        console.log(error)
      }
    }
  },
  mounted () {
    this.getbuyInfo()
  },
  created () {
    console.log(typeof Paddle)
    if (typeof Paddle === 'undefined') {
      var head = document.getElementsByTagName('head')[0]
      let script = document.createElement('script')
      script.src = 'https://cdn.paddle.com/paddle/paddle.js'
      head.appendChild(script)
      script.onload = () => {
        let Paddle = window.Paddle
        Paddle && Paddle.Setup({ vendor: 40431 })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.buy-main-btn{
  width: 60%;
  height: 42px;
  font-size: 18px !important;
}
.buy-main-row{
  // padding:0 10%;
  // height: 100%;
  width: 100%;
}
.buy_margin_sub {
  margin-right: 20px;
  margin-bottom: 30px;
}
.grid-content {
  padding: 50px 40px;
}
.grid-content-p{
  font-size: 26px;
  line-height: 54px;
  color: #333333;
  margin-top: 10%;
}
.grid-content-month-p{
  font-size: 22px;
  line-height: 54px;
  letter-spacing: 0px;
  color: #2bcf88;
}
.grid-content-devices-p {
  font-size: 18px;
  line-height: 42px;
  color: #777777;
  padding: 20px 0;
}
// .home_wrap_buy {
//   height:92%;
// }
.home-wrap{
  width:100%;
  box-sizing: border-box;
  .buy-table{
    background-color: #ffffff;
    box-shadow: 4px 0px 8px 0px rgba(0, 0, 0, 0.05);
    border-radius: 20px;
    // height: 100%;
    width: 100%;
    .buy-header{
      width:100%;
      height:9%;
      box-sizing: border-box;
      border-bottom:1px solid #e5e5e5;
      color: #333333;
      font-size: 24px;
      padding: 20px;
    }
    .buy-footer{
      width:100%;
      height:9%;
      border-top:1px solid #e5e5e5;
      padding:15px 0;
      .buy-footer-btn{
        height: 50px;
        width: 191px;
        font-size:20px;
     }
    }
    .buy-main{
      width: 100%;
      .buy-main-choose{
        font-size: 24px;
        font-weight: normal;
        font-stretch: normal;
        padding: 4% 0;
        color: #333333;
      }
      .buy-main-note{
        font-size: 16px;
        color: #888888;
        padding-bottom: 30px;
      }
      .buy-main-bound{
        width: 100%;
        height: 100%;
        .grid-content{
          height: 100%;
          background-color: #ffffff;box-shadow: 2px 0px 20px 0px rgba(0, 0, 0, 0.1);border-radius: 20px;border: solid 2px #e5e5e5;
        }
      }
    }
  }
}
@media (max-width: 1024px){
  .buy_footer_none, .buy_header_none, .buy_main_note_none{
    display: none !important;
  }
  .home-wrap .buy-table .buy-header {
    display: none;
  }
  .buy-main-bound .buy_main_low{
    flex-flow: column nowrap !important;
  }
  // .home-wrap .buy-table .buy_main_col {
  //   height: 100%;
  // }
}
</style>



// WEBPACK FOOTER //
// src/components/Buy.vue